import gql from 'graphql-tag';

export default gql`
  mutation DietMealReplaceProductMutation($productAmountId: Int!, $replacementId: String!) {
    me {
      dietMealReplaceProduct(productAmountId: $productAmountId, replacementId: $replacementId) {
        __typename
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on BasicMutationSuccess {
          code
        }
      }
    }
  }
`;
